import { css } from '@microsoft/fast-element';
import { focusStrokeOuter, foregroundOnPrimaryRest, neutralForegroundActive, neutralForegroundRest, neutralInputFillActive, neutralInputFillHover, neutralInputFillRest, neutralStrokeActive, neutralStrokeFocus, neutralStrokeHover, neutralStrokeRest, getToken } from '../../design-tokens';
import { heightNumber } from '../../styles/size';
import { display } from '../../foundation/display';

// TODO: Token for max checkbox border radius?

export const checkboxStyles = css`
    ${display("inline-flex")} :host {
        position: relative;
        align-items: center;
        outline: none;
        margin: calc(${getToken('space-design-unit')} * 1px) 0;
        ${
            /*
             * Chromium likes to select label text or the default slot when
             * the checkbox is clicked. Maybe there is a better solution here?
             */ ""
        } user-select: none;
    }
    .control {
        --control-size: calc(((${heightNumber} / 2) + (${getToken('space-stroke-width')} * 2)) * 1px);
        position: relative;
        flex-shrink: 0;
        padding: calc(${getToken('space-design-unit')} * 0.5px);
        width: var(--control-size);
        height: var(--control-size);
        box-sizing: border-box;
        border-radius: min(calc(${getToken('space-input-corner-radius')} * 1px), 4px);
        border: calc(${getToken('space-stroke-width')} * 1px) solid ${neutralStrokeRest};
        background: ${neutralInputFillRest};
        outline: none;
        cursor: pointer;
    }
    :host(:hover) .control {
        background: ${neutralInputFillHover};
        border-color: ${neutralStrokeHover};
    }
    :host(:active) .control {
        background: ${neutralInputFillActive};
        border-color: ${neutralStrokeActive};
    }
    :host(:focus-visible) .control {
        border-color: ${neutralStrokeFocus};
        outline: calc(${getToken('space-focus-stroke-width')} * 1px) solid ${focusStrokeOuter};
        outline-offset: calc(${getToken('space-stroke-width')} * 1px);
    }
    :host([aria-checked="true"]) .control {
        background: ${getToken('color-primary-base')};
        border-color: ${getToken('color-primary-base')};
    }
    :host([aria-checked="true"]:enabled:hover) .control {
        background: ${getToken('color-primary-hover')};
        border-color: ${getToken('color-primary-hover')};
    }
    :host([aria-checked="true"]:enabled:active) .control {
        background: ${getToken('color-primary-active')};
        border-color: ${getToken('color-primary-active')};
    }
    :host([aria-checked="true"]:enabled:focus-visible) .control {
        background: ${getToken('color-primary-focus')};
        border-color: ${getToken('color-primary-focus')};
    }
    .label__hidden {
        display: none;
        visibility: hidden;
    }
    .label {
        font-family: ${getToken('typography-font-family')};
        color: currentColor;
        padding-inline-start: calc(${getToken('space-design-unit')} * 2px + 2px);
        cursor: pointer;
    }
    slot[name="checked-indicator"],
    slot[name="indeterminate-indicator"] {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        opacity: 0;
        pointer-events: none;
    }
    slot[name="checked-indicator"] {
        fill: ${foregroundOnPrimaryRest};
    }
    slot[name="indeterminate-indicator"] {
        fill: ${neutralForegroundActive};
        position: absolute;
        top: 0;
    }

    slot[name="checked-indicator"] svg,
    slot[name="indeterminate-indicator"] svg {
        height: 100%;
    }

    :host(.disabled) .label,
    :host(.readonly) .label,
    :host(.readonly) .control,
    :host(.disabled) .control {
        cursor: not-allowed;
    }
    :host([aria-checked="true"]:not(.indeterminate)) slot[name='checked-indicator'],
    :host([aria-checked="true"].indeterminate) slot[name='indeterminate-indicator'] {
        opacity: 1;
    }
    :host(.disabled) {
        opacity: ${getToken('color-disabled-opacity')};
    }
    :host([aria-checked="true"].indeterminate) .control {
        background: ${neutralInputFillActive};
        border-color: ${neutralStrokeRest};
    }
    :host([aria-checked="true"].indeterminate:hover) .control {
        background: ${neutralInputFillActive};
        border-color: ${neutralStrokeHover};
    }
    :host([aria-checked="true"].indeterminate:active) .control {
        background: ${neutralInputFillActive};
        border-color: ${neutralStrokeActive};
    }
    :host([aria-checked="true"].indeterminate:focus-visible) .control {
        background: ${neutralInputFillActive};
        border-color: ${neutralStrokeFocus};
        box-shadow: 0 0 0 calc(${getToken('space-stroke-width')} * 1px) ${neutralInputFillRest},
        0 0 0 calc(${getToken('space-focus-stroke-width')} * 1px) ${neutralStrokeFocus};
   }
  `;
